import instance from 'utils/axios/instance.axios';
import { ORGANIZATIONS } from './_constant';

export const getAll = () => instance.get(ORGANIZATIONS.GET_ALL);

export const getAllByUser = () => instance.get(ORGANIZATIONS.GET_ALL_BY_USER);

export const getAllForAdministration = (pagination, filters, showMode) =>
  instance.get(ORGANIZATIONS.GET_ALL_FOR_ADMINISTRATION, {
    params: { ...pagination, ...filters, showMode },
  });

export const getById = (id = '') => instance.get(ORGANIZATIONS.GET_BY_ID(id));

export const create = (data = {}) => instance.post(ORGANIZATIONS.CREATE, data);

export const update = ({ id, data = {} }) => instance.patch(ORGANIZATIONS.UPDATE(id), data);

export const deleteById = (id) => instance.delete(ORGANIZATIONS.DELETE(id));

export const restore = (id) => instance.patch(ORGANIZATIONS.RESTORE(id));

export const reorder = (data = {}) => instance.post(ORGANIZATIONS.REORDER, data);
